import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'
import {ISurveyCategoryPayload} from '../../SERVICE-INTERFACES'

const surveyCategory_endpoints = APIS_ENDPOINTS.surveyCategory

export const request_create = async ({Name, Id}: ISurveyCategoryPayload) => {
  const formData = new FormData()
  formData.append('Name', Name)
  formData.append('Id', Id?.toString() || '')

  return http.post(surveyCategory_endpoints.create, formData)
}
export const request_edit = async ({Name, Id}: ISurveyCategoryPayload) => {
  const formData = new FormData()
  formData.append('Name', Name)
  formData.append('Id', Id?.toString() || '')

  return http.put(surveyCategory_endpoints.edit, formData)
}

export const request_getAll = async ({
  search,
  CurrentPage,
  PageSize,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
}) => {
  return http.get(
    surveyCategory_endpoints.getlist +
      `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}`
  )
}

export const request_delete = async (id: number) => {
  return http.delete(surveyCategory_endpoints.delete + `?Id=${id}`)
}

export const request_unactive = async (id: number) => {
  return http.delete(surveyCategory_endpoints.unactive + `?Id=${id}`)
}

export const request_active = async (id: number) => {
  return http.put(surveyCategory_endpoints.active + `?Id=${id}`)
}

export const request_setDefault = async (id: number) => {
  return http.put(surveyCategory_endpoints.setdefault + `?Id=${id}`)
}
